import React, { Component } from 'react';

import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';


import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

import utils from 'Utils/index.js';

class DeliveryStatisticsWithData extends Component{
  render() {

    const {data: {loading, deliveries, refetch}, app_data, filter_data} = this.props;

    if(loading) {
      return (<div>Загрузка</div>);
    }

    const {
      INITIALIZED,
      COMPLETED,
      IN_PROGRESS,
      CANCELED
    } = app_data.constants.delivery;

    return (

      <div>

        <table className="table fixed full_width">

          <thead className="table__thead">
            <tr>
              <th>Дата</th>
              <th>Время</th>
              <th>Тип доставки</th>
              <th>Статус</th>
              <th>Устройство</th>
              <th>Адрес</th>
              <th>Комментарий</th>
            </tr>
          </thead>

          <tbody className="table__tbody">

            {deliveries.map((delivery) => {

              const date = moment(new Date(delivery.date)).format(utils.DATE_FORMAT);

              const delivery_type = delivery.type_id ? app_data.delivery_types[delivery.type_id].title : '';

              const delivery_status = delivery.status_id ? app_data.delivery_statuses[delivery.status_id].title : '';


              const lead = delivery.lead;

              const lead_title = lead ? `${lead.remonline_data} ${lead.act_number}` : '';

              const lead_address = lead ? lead.client.address : '';

              const address = delivery.address && delivery.address.length ? delivery.address : lead_address;



              return <tr key={delivery.id}>
                <td>{date}</td>
                <td>{delivery.time}</td>
                <td>{delivery_type}</td>
                <td>{delivery_status}</td>
                <td>{lead_title}</td>
                <td>{address}</td>
                <td>{delivery.comment}</td>
              </tr>
            })}

          </tbody>

        </table>



      </div>

    );
  }
}


export default compose(

  graphql(gql`query deliveries(
      $start_date: String!,
      $end_date: String!,
    ){
    deliveries(
      start_date: $start_date,
      end_date: $end_date,
    ){
      id,
      date,
      phone,
      type_id,
      lead_id,
      address,
      comment,
      user_id,
      status_id,
      contractor_id,
      index,
      time,
      complete,
      created_at
      lead {
        id,
        remonline_id,
        remonline_data,
        remonline_device,
        remonline_model,
        act_number,
        client {
          phone,
          address
        }
      }
      
    }
  }`, {
    options: ({filter_data: {
      start_date,
      end_date,
    }}) => {

      return {
        variables: {
          start_date: start_date.toDate(),
          end_date: end_date.toDate(),
        }
      }

    }
  }),


)(DeliveryStatisticsWithData);